import React, { useState, useEffect, useMemo } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { animated, useTransition } from 'react-spring';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useInView } from 'react-intersection-observer';
import './AboutSection.css';

const AboutSection = () => {
  const [index, setIndex] = useState(0);
  const [ref, inView] = useInView();
  const items = [
    { text: 'Full Stack Developer', color: '#00eeff', shadow: '#1d1d1d' },
    { text: 'Community Manager', color: '#00eeff', shadow: '#1d1d1d' },
    { text: 'Tutor Experimentado', color: '#00eeff', shadow: '#1d1d1d' },
  ];

  const skills = useMemo(() => [
    { name: 'React', value: 90 },
    { name: 'Angular', value: 80 },
    { name: 'JavaScript', value: 90 },
    { name: 'Node', value: 90 },
    { name: 'Django', value: 80 },
    { name: 'Python', value: 90 },
  ], []);

  const qualities = [
    { text: 'Liderazgo Natural', color: '#ffbb00', shadow: '#1d1d1d' },
    { text: 'Capacidad Analítica', color: '#ffbb00', shadow: '#1d1d1d' },
    { text: 'Estrategias Creativas', color: '#ffbb00', shadow: '#1d1d1d' },
  ];  

  const [qualityIndex, setQualityIndex] = useState(0);

  const [values, setValues] = useState(skills.map(() => 0));

  useEffect(() => {
    const interval = setInterval(() => {
      setQualityIndex((state) => (state + 1) % qualities.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [qualities.length]);
  

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((state) => (state + 1) % items.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [items.length]);

  useEffect(() => {
    const interval = setInterval(() => {
      setValues((values) =>
        values.map((value, i) => Math.min(value + 5, skills[i].value))
      );
    }, 50);
    return () => clearInterval(interval);
  }, [skills]);
  
  useEffect(() => {
    if (inView) {
      // Si los círculos están visibles, cargar la animación
      const interval = setInterval(() => {
        setValues((values) =>
          values.map((value, i) => Math.min(value + 5, skills[i].value))
        );
      }, 50);
      return () => clearInterval(interval);
    } else {
      // Si los círculos no están visibles, descargar la animación
      const interval = setInterval(() => {
        setValues((values) =>
          values.map((value) => Math.max(value - 5, 0))
        );
      }, 50);
      return () => clearInterval(interval);
    }
  }, [skills, inView]);

  useEffect(() => {
    if (inView) {
      // Si los círculos están visibles, cargar la animación
      const interval = setInterval(() => {
        setValues((values) =>
          values.map((value, i) => Math.min(value + 5, skills[i].value))
        );
      }, 50);
      return () => clearInterval(interval);
    } else {
      // Si los círculos no están visibles, descargar la animación
      const interval = setInterval(() => {
        setValues((values) =>
          values.map((value) => Math.max(value - 5, 0))
        );
      }, 50);
      return () => clearInterval(interval);
    }
  }, [skills, inView]);
  

  const transitions = useTransition(index, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });
  
  const qualityTransitions = useTransition(qualityIndex, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });  

  return (
    <section id="about">
      <Container className="contiene-about">
        <Row>
          <Col md={12} className="text-center">
            <h2>Quien Soy</h2>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="order-md-last">
            <div className="profile-pic">
              <Image src="/images/sticker-me.png" fluid alt="Perfil" />
            </div>
          </Col>
          <Col md={6}>
          <div className="center-content-mobile" style={{ display: 'inline-block', width: '100%' }}>
  <p style={{ display: 'inline-block' }}>Soy Alex Franco</p>
  <div style={{ display: 'inline-block', position: 'relative', height: '2.2em', overflow: 'hidden', minWidth: '300px', marginLeft: '10px' }}>
    {transitions((style, i) => (
      <animated.div style={{ ...style, position: 'absolute', color: items[i].color, textShadow: `1px 1px ${items[i].shadow}`, fontWeight: 'bold', fontSize: '1.5em', overflow:'hidden' }}>
        {items[i].text}
      </animated.div>
    ))}
  </div>
</div>


            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
              <p style={{ margin: 0 }}>Poseo</p>
              <div style={{ height: '2.2em', overflow: 'hidden', marginLeft: '10px' }}>
                {qualityTransitions((style, i) => (
                <animated.div style={{ ...style, position: 'absolute', color: qualities[i].color, textShadow: `1px 1px ${qualities[i].shadow}`, fontWeight: 'bold', fontSize: '1.5em', overflow:'hidden' }}>
                  { qualities[i].text}
                </animated.div>
                 ))}
              </div>
            </div>
            
            <p style={{ marginBottom: '20px' }}>Me enfoco en:</p>

            <Row ref={ref} style={{ marginBottom:'10px'}}>
              {skills.slice(0,3).map((skill, i) => (
                <Col key={skill.name} xs={4}>
<div style={{ position: 'relative', width: '100px' }}>
<svg style={{ position: 'absolute', zIndex: 0, width: '100px', height: '100px' }}>
  <circle cx="50" cy="50" r="45" fill="#000000" />
</svg>
  <div style={{ position: 'relative', zIndex: 1 }}>
    <CircularProgressbar
      value={values[i]}
      text={skill.name}
      styles={buildStyles({
        pathColor: values[i] === skill.value ? '#00ff00' : '#00ff00',
        trailColor: values[i] === skill.value ? '#4d4d4d' : '#4d4d4d',
        textSize: '16px',
        fontFamily: 'Arial Black',
      })}
    />
  </div>
</div>
                </Col>
              ))}
            </Row>
<Row ref={ref} style={{ marginBottom:'10px'}}>
  {skills.slice(3).map((skill, i) => (
    <Col key={skill.name} xs={4}>
      <div style={{ position: 'relative', width: '100px' }}>
        <svg style={{ position: 'absolute', zIndex: 0, width: '100px', height: '100px' }}>
          <circle cx="50" cy="50" r="45" fill="#000000" />
        </svg>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <CircularProgressbar
            value={values[i + 3]} // Ajusta el índice aquí
            text={skill.name}
            styles={buildStyles({
              pathColor: values[i + 3] === skill.value ? '#00ff00' : '#00ff00', // Y aquí
              trailColor: values[i + 3] === skill.value ? '#4d4d4d' : '#4d4d4d', // Y aquí
              textSize: '16px',
              fontFamily: 'Arial Black',
            })}
          />
        </div>
      </div>
    </Col>
  ))}
</Row>




<div className="contact-me">
  <a href="mailto:alexleaderhere@gmail.com" className="icon-button">
    <FontAwesomeIcon icon={faEnvelope} />
    <span className="button-text">Mail</span>
  </a>
  <a href="/documents/CVAlexFullStack.pdf" className="icon-button" download>
    <FontAwesomeIcon icon={faFileDownload} />
    <span className="button-text">CV</span>
  </a>
</div>

          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default AboutSection;
